import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate, useParams } from "react-router-dom";
import {
  editCollection,
  viewOneCollection,
} from "../../Redux/Actions/collectionsActions";
import { useDispatch, useSelector } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const EditSubCollections = () => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [subCollectionState, setSubCollectionState] = useState({
    id: id,
    name: "",
    image: "",
    collection_id: "",
    banner_image: "",
    banner_title: "",
    three_d_icon: "",
  });

  useEffect(() => {
    dispatch(viewOneCollection(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { individualCollection } = useSelector((state) => {
    return state.collections || {};
  });

  useEffect(() => {
    if (individualCollection?.data) {
      setSubCollectionState((prevData) => ({
        ...prevData,
        ...individualCollection.data,
        id: id,
      }));
    }
  }, [individualCollection, id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const filteredData = Object.fromEntries(
        Object.entries(subCollectionState).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );
      const response = await dispatch(editCollection(filteredData));
      if (response.statusCode === 200) {
        navigate(-1);
      }
    } catch (error) {
      console.log(error?.data?.response?.message);
    }
  };

  const handleImageUpload = async (event, type) => {
    const uploadedFile = event.target.files[0];

    if (!uploadedFile) return;
    const responseUrl = await AddImage(uploadedFile);
    if (responseUrl) {
      setSubCollectionState((prevData) => ({
        ...prevData,
        [type]: responseUrl,
      }));
    }
  };

  return (
    <MainLayout>
      <div className="grid-span-5 margin-h-10 bg-white border-24">
        <div className="flex-container flex-justify-between padding-20">
          <h1>Edit Sub Collection</h1>

          <button onClick={() => navigate(-1)} className="button-class">
            Go Back
          </button>
        </div>
        <form style={{ padding: "0px 20px" }}>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <span className="span-class">Change Collection's Image</span>
              <input
                style={{
                  display: "none",
                }}
                onChange={(event) => handleImageUpload(event, "image")}
                type="file"
                name="image"
                id="image"
              />
              <label className="label-class-image" for="image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCollectionState.image}
                keyField="image"
                setState={setSubCollectionState}
                state={subCollectionState}
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class">Change Collection's Icon</span>
              <input
                style={{
                  display: "none",
                }}
                onChange={(event) => handleImageUpload(event, "icon")}
                type="file"
                name="icon"
                id="icon"
              />
              <label className="label-class-image" for="icon">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCollectionState.icon}
                keyField="icon"
                setState={setSubCollectionState}
                state={subCollectionState}
              ></ImageShowerModalGlobal>
            </div>
          </div>

          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <span className="span-class">
                Change Collection's Banner Image
              </span>
              <input
                style={{
                  display: "none",
                }}
                onChange={(event) => handleImageUpload(event, "banner_image")}
                type="file"
                name="banner_image"
                id="banner_image"
              />
              <label className="label-class-image" for="banner_image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCollectionState.banner_image}
                keyField="banner_image"
                setState={setSubCollectionState}
                state={subCollectionState}
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class">Change Collection's 3D Icon</span>
              <input
                style={{
                  display: "none",
                }}
                onChange={(event) => handleImageUpload(event, "three_d_icon")}
                type="file"
                name="three_d_icon"
                id="three_d_icon"
              />
              <label className="label-class-image" for="three_d_icon">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCollectionState.three_d_icon}
                keyField="three_d_icon"
                setState={setSubCollectionState}
                state={subCollectionState}
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <span className="span-class">Change Collection's Name</span>
              <input
                className="input-class"
                type="text"
                name="name"
                value={subCollectionState.name}
                onChange={(event) =>
                  setSubCollectionState((prevData) => ({
                    ...prevData,
                    name: event.target.value,
                  }))
                }
                placeholder="Enter Name"
              />
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class">Change Banner's Name</span>
              <input
                className="input-class"
                type="text"
                name="banner_title"
                value={subCollectionState.banner_title}
                onChange={(event) =>
                  setSubCollectionState((prevData) => ({
                    ...prevData,
                    banner_title: event.target.value,
                  }))
                }
                placeholder="Enter Name"
              />
            </div>
          </div>
          <div className="flex-end" style={{ margin: "20px 0px" }}>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="button-class-white"
            >
              Cancel
            </button>
            <button
              className="button-class"
              onClick={handleSubmit}
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditSubCollections;
